export default __webpack_public_path__ + "static/media/email-registration-bg.4b8ce590.jpg";